import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { AuthService } from './services/auth.service';

@Injectable()
export class AuthGuard  {
  constructor(private authService: AuthService, private router: Router) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canAccess(state.url);
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
    const url = segments.length ? `/${segments.map(s => s.path).join('/')}` : this.router.url;
    return this.canAccess(url);
  }

  private canAccess(returnUrl: string): Observable<boolean> {
    return this.authService.authReady$.pipe(
      filter(ready => ready),
      take(1),
      map(() => {
        if (this.authService.isAuthenticated()) {
          return true;
        }

        this.authService.login(returnUrl);
        return false;
      })
    );
  }
}
